var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLuasBerhasil(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Luas_Berhasil",
    "data-name": "Luas Berhasil",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1296",
    "data-name": "Path 1296",
    d: "M884.572,1189.976a2.571,2.571,0,1,1,2.571-2.572A2.575,2.575,0,0,1,884.572,1189.976Zm0-4.286a1.714,1.714,0,1,0,1.714,1.714A1.716,1.716,0,0,0,884.572,1185.69Z",
    transform: "translate(-863.142 -1165.976)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1297",
    "data-name": "Path 1297",
    d: "M866.572,1189.976a2.571,2.571,0,1,1,2.572-2.572A2.575,2.575,0,0,1,866.572,1189.976Zm0-4.286a1.714,1.714,0,1,0,1.714,1.714A1.716,1.716,0,0,0,866.572,1185.69Z",
    transform: "translate(-864 -1165.976)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1298",
    "data-name": "Path 1298",
    d: "M875.572,1189.976a2.571,2.571,0,1,1,2.572-2.572A2.575,2.575,0,0,1,875.572,1189.976Zm0-4.286a1.714,1.714,0,1,0,1.714,1.714A1.716,1.716,0,0,0,875.572,1185.69Z",
    transform: "translate(-873 -1184.833)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2772",
    "data-name": "Path 2772",
    d: "M552.429,307.429A.429.429,0,0,1,552,307V292.429a.429.429,0,0,1,.857,0V307A.429.429,0,0,1,552.429,307.429Z",
    transform: "translate(-549.429 -287.714)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2773",
    "data-name": "Path 2773",
    d: "M569,311.857H554.429a.429.429,0,1,1,0-.857H569a.429.429,0,0,1,0,.857Z",
    transform: "translate(-549.714 -290.428)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2774",
    "data-name": "Path 2774",
    d: "M826,1325.857h-2.571a.429.429,0,1,1,0-.857H826a.429.429,0,0,1,0,.857Z",
    transform: "translate(-820.429 -1318.143)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2777",
    "data-name": "Path 2777",
    d: "M826,1325.857h-2.571a.429.429,0,1,1,0-.857H826a.429.429,0,0,1,0,.857Z",
    transform: "translate(-820.429 -1307.857)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2779",
    "data-name": "Path 2779",
    d: "M3,.857H.429A.429.429,0,0,1,.429,0H3A.429.429,0,0,1,3,.857Z",
    transform: "translate(6.857 18) rotate(90)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2780",
    "data-name": "Path 2780",
    d: "M3,.857H.429A.429.429,0,0,1,.429,0H3A.429.429,0,0,1,3,.857Z",
    transform: "translate(12 18) rotate(90)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2781",
    "data-name": "Path 2781",
    d: "M3,.857H.429A.429.429,0,0,1,.429,0H3A.429.429,0,0,1,3,.857Z",
    transform: "translate(17.143 18) rotate(90)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2778",
    "data-name": "Path 2778",
    d: "M826,1325.857h-2.571a.429.429,0,1,1,0-.857H826a.429.429,0,0,1,0,.857Z",
    transform: "translate(-820.429 -1313)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_617",
    "data-name": "Group 617",
    transform: "translate(7.714 4.286)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2030",
    "data-name": "Path 2030",
    d: "M970.655,972c-1.636,0-1.655-1.238-1.655-1.25a.25.25,0,0,1,.5,0c0,.078.052.752,1.155.752a.967.967,0,0,0,1.064-.878,1.3,1.3,0,0,0-1.114-1.377,1.792,1.792,0,0,1-1.512-1.917A1.47,1.47,0,0,1,970.655,966,1.246,1.246,0,0,1,972,967.25a.25.25,0,0,1-.5,0,.75.75,0,0,0-.845-.75.967.967,0,0,0-1.064.878,1.3,1.3,0,0,0,1.113,1.377,1.792,1.792,0,0,1,1.513,1.917A1.471,1.471,0,0,1,970.655,972Zm-1.155-1.25h0Z",
    transform: "translate(-964.5 -963)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2031",
    "data-name": "Path 2031",
    d: "M972.25,965.5a.25.25,0,0,1-.25-.25v-1a.25.25,0,0,1,.5,0v1A.25.25,0,0,1,972.25,965.5Z",
    transform: "translate(-966 -962)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2032",
    "data-name": "Path 2032",
    d: "M972.25,978.5a.25.25,0,0,1-.25-.25v-1a.25.25,0,1,1,.5,0v1A.25.25,0,0,1,972.25,978.5Z",
    transform: "translate(-966 -968.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2033",
    "data-name": "Path 2033",
    d: "M966,972a6,6,0,1,1,6-6A6.007,6.007,0,0,1,966,972Zm0-11.5a5.5,5.5,0,1,0,5.5,5.5A5.507,5.507,0,0,0,966,960.5Z",
    transform: "translate(-960 -960)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLuasBerhasil);
export default __webpack_public_path__ + "static/media/luasBerhasil.92871b3c9d592abeed008cd3a875a8c4.svg";
export { ForwardRef as ReactComponent };